export const deleteItem = "$Ma";
export default {deleteItem};